import axios from 'axios'

export default {
    async fetchAll(params) {
        const response = await axios.get('/api/xml_upload_requests', { params });
        return response.data;
    },
    async fetch(id) {
        const response = await axios.get(`/api/xml_upload_requests/${id}`);
        return response.data.xml_upload_request;
    },
    async fetchRequestsForTargets({ filters = {} }) {
        const response = await axios.post('/api/upload_requests_results', filters);
        return response.data;
    },
    async fetchRequestsForTargetAndDate(requestsDate, targetBuildId) {
        const response = await axios.get('/api/upload_requests_for_date', { params: {
                target_build_id: targetBuildId,
                requests_date: requestsDate,
            }});
        return response.data;
    },
}
